// extracted by mini-css-extract-plugin
export default {"main":"Server_main__tzsKH","busy":"Server_busy__p81Do","blink":"Server_blink__nObE4","icon":"Server_icon__zy9ZU"};